import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { AddNotificationsViewModel, BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import {
    ApplicationFacade,
    SearchResult,
    SearchService,
    StopRouteResult,
    TransitNetworkPartType
} from '@ridango/components';
import { combineLatest, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'rwidget-add-notifications',
    templateUrl: './add-notifications.component.html',
    styleUrls: ['./add-notifications.component.scss']
})
export class AddNotificationsComponent extends BaseComponent implements OnDestroy {
    @ViewChild('input') input;

    assetsPath$ = this.applicationFacade.assetsPath$;
    searchPhrase$ = new Subject<string>();
    searchValue = '';
    readonly AddNotificationsViewModel$: Observable<AddNotificationsViewModel>;

    constructor(
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env,
        private searchService: SearchService,
        private translate: TranslateService
    ) {
        super();
        this.AddNotificationsViewModel$ = this.initSearch();
    }

    handleBackClicked(): void {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = '/';
        }
    }

    onSearchChange(inputValue: string): void {
        this.searchValue = inputValue;
        this.searchPhrase$.next(inputValue);
    }

    //HANDLING ITEM SELECTION WILL BE DONE IN ANOTHER PR
    handleSearchItemSelect(selectedItem: StopRouteResult): void {
        switch (selectedItem.type) {
            case TransitNetworkPartType.Stop:
                //SELECTION LOGIC
                break;
            case TransitNetworkPartType.Route:
                //SELECTION LOGIC
                break;
        }
    }

    private initSearch(): Observable<AddNotificationsViewModel> {
        const searchValue$ = this.searchPhrase$.pipe(startWith(''), debounceTime(300), distinctUntilChanged());

        const searchLoading$ = this.searchService.searchLoading.pipe(
            map((loading) => Object.values(loading).some((value) => value))
        );

        const searchResults$ = combineLatest([
            this.searchService.InitSearch(this.searchPhrase$, 10, TransitNetworkPartType.Stop),
            this.searchService.InitSearch(this.searchPhrase$, 10, TransitNetworkPartType.Route),
            searchValue$
        ]).pipe(
            tap(([result]) => {
                this.searchService.updateSearchResultsAnnouncementMessage(result);
            }),
            map(([stopResults, routeResults, searchPhrase]) => {
                const combinedResults = {
                    stopRoutes: [...(stopResults.stopRoutes || []), ...(routeResults.stopRoutes || [])],
                    addresses: [],
                    poi: []
                };
                return {
                    results: {
                        stopRoutes: combinedResults.stopRoutes?.slice(0, 10) ?? [],
                        addresses: [],
                        poi: []
                    } as SearchResult,
                    searchText: searchPhrase
                };
            })
        );

        return combineLatest([searchResults$, searchLoading$]).pipe(
            map(([searchData, isLoading]) => ({ ...searchData, isLoading }))
        );
    }
}
